module.exports = __webpack_public_path__ + "static/media/boneescapedavide.d46d23c5.png";